import React from 'react';
import { Spotlight, SpotlightActionData } from '@mantine/spotlight';
import { rem } from '@mantine/core';
import { Search } from 'tabler-icons-react';

interface SpotlightSearchProps {
  actions: SpotlightActionData[];
  onSearchChange: (query: string) => void;
  isSearching?: boolean;
}

const SpotlightSearch: React.FC<SpotlightSearchProps> = ({ actions, onSearchChange, isSearching = false }) => {
  console.log('=== SPOTLIGHTSEARCH COMPONENT DEBUG ===');
  console.log('Received actions:', actions);
  console.log('Actions length:', actions.length);
  console.log('Actions sample:', actions.slice(0, 2));

  console.log('=== LEFTSECTION DEBUG ===');
  console.log('First action leftSection:', actions[0]?.leftSection);
  console.log('First action leftSection type:', typeof actions[0]?.leftSection);
  console.log('Is leftSection a React element?', React.isValidElement(actions[0]?.leftSection));

  const handleSearchChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    onSearchChange(event.currentTarget.value);
  };

  return (
    <Spotlight
      actions={actions}
      nothingFound="No results found..."
      highlightQuery
      searchProps={{
        leftSection: <Search style={{ width: rem(20), height: rem(20) }} />,
        placeholder: 'Search areas, artists, events, dance styles, event types, posts...',
        onChange: handleSearchChange,
      }}
      styles={{
        root: {
          '--spotlight-bg': '#171717',
          '--spotlight-border': '#EA580C',
        },
        content: {
          backgroundColor: '#171717',
          maxHeight: '100vh',
        },
        actionsGroup: {
          maxHeight: '80vh',
          overflowY: 'auto',
        },
        actionsList: {
          maxHeight: '80vh',
          overflowY: 'auto',
          paddingBottom: actions.length > 6 ? rem(108) : 0,
        },
        action: {
          '&[data-selected]': {
            backgroundColor: '#EA580C',
          },
          '&:hover': {
            backgroundColor: 'rgba(234, 88, 12, 0.1)',
          },
        },
        actionLabel: {
          color: '#ffffff',
          fontWeight: 700,
        },
        actionDescription: {
          color: '#EA580C',
        },
        search: {
          backgroundColor: '#75757510',
          borderColor: '#EA580C',
          color: '#ffffff',
          '&::placeholder': {
            color: '#9CA3AF',
          },
        },
      }}
      shortcut={['mod + K', '/']}
      limit={12}
    />
  );
};

export default SpotlightSearch;
